export const bookLocationsTranslations = {
  ar: {
    title: 'إدارة أماكن الكتب',
    description: 'إدارة أماكن الكتب في المكتبة',
    addBookLocation: 'إضافة مكان كتاب',
    loading: 'جاري تحميل أماكن الكتب...',
    errorLoading: 'حدث خطأ في تحميل أماكن الكتب',
    noBookLocations: 'لا توجد أماكن كتب',
    createSuccess: 'تم إنشاء مكان الكتاب بنجاح',
    createError: 'فشل إنشاء مكان الكتاب',
    updateSuccess: 'تم تحديث مكان الكتاب بنجاح',
    updateError: 'فشل تحديث مكان الكتاب',
    deleteSuccess: 'تم حذف مكان الكتاب بنجاح',
    deleteError: 'فشل حذف مكان الكتاب',
    confirmDelete: 'هل أنت متأكد من حذف مكان الكتاب {code}؟',
    allBranches: 'جميع الفروع',
    search: 'بحث...',
    gridView: 'عرض شبكي',
    listView: 'عرض قائمة',
    occupied: 'محجوز',
    available: 'متاح',
    capacity: 'السعة:',
    locationCode: 'رمز المكان',
    locationName: 'اسم المكان',
    section: 'القسم',
    shelf: 'الرف',
    row: 'الصف',
    column: 'العمود',
    floor: 'الطابق',
    room: 'الغرفة',
    notes: 'ملاحظات',
    isActive: 'نشط',
    edit: 'تعديل',
    delete: 'حذف',
    editBookLocation: 'تعديل مكان الكتاب',
    addNewBookLocation: 'إضافة مكان كتاب جديد',
    selectBranch: 'اختر الفرع',
    locationCodeRequired: 'رمز المكان مطلوب',
    optionalName: 'اسم اختياري',
    shelfRowColumn: 'الرف/الصف/العمود',
    status: 'الحالة',
    actions: 'الإجراءات',
    roomName: 'اسم القاعة أو الغرفة',
    numberOfBooks: 'عدد الكتب',
    active: 'نشط',
    yes: 'نعم',
    additionalNotes: 'ملاحظات إضافية...',
    saving: 'جاري الحفظ...',
    save: 'حفظ',
    cancel: 'إلغاء',
    name: 'الاسم',
  },
  en: {
    title: 'Book Locations Management',
    description: 'Manage book locations in library',
    addBookLocation: 'Add Book Location',
    loading: 'Loading book locations...',
    errorLoading: 'Error loading book locations',
    noBookLocations: 'No book locations found',
    createSuccess: 'Book location created successfully',
    createError: 'Failed to create book location',
    updateSuccess: 'Book location updated successfully',
    updateError: 'Failed to update book location',
    deleteSuccess: 'Book location deleted successfully',
    deleteError: 'Failed to delete book location',
    confirmDelete: 'Are you sure you want to delete book location {code}?',
    allBranches: 'All Branches',
    search: 'Search...',
    gridView: 'Grid View',
    listView: 'List View',
    occupied: 'Occupied',
    available: 'Available',
    capacity: 'Capacity:',
    locationCode: 'Location Code',
    locationName: 'Location Name',
    section: 'Section',
    shelf: 'Shelf',
    row: 'Row',
    column: 'Column',
    floor: 'Floor',
    room: 'Room',
    notes: 'Notes',
    isActive: 'Active',
    edit: 'Edit',
    delete: 'Delete',
    editBookLocation: 'Edit Book Location',
    addNewBookLocation: 'Add New Book Location',
    selectBranch: 'Select Branch',
    locationCodeRequired: 'Location code is required',
    optionalName: 'Optional name',
    shelfRowColumn: 'Shelf/Row/Column',
    status: 'Status',
    actions: 'Actions',
    roomName: 'Room name',
    numberOfBooks: 'Number of books',
    active: 'Active',
    yes: 'Yes',
    additionalNotes: 'Additional notes...',
    saving: 'Saving...',
    save: 'Save',
    cancel: 'Cancel',
    name: 'Name',
  },
  fr: {
    title: 'Gestion des emplacements de livres',
    description: 'Gérer les emplacements de livres dans la bibliothèque',
    addBookLocation: 'Ajouter un emplacement de livre',
    loading: 'Chargement des emplacements de livres...',
    errorLoading: 'Erreur lors du chargement des emplacements de livres',
    noBookLocations: 'Aucun emplacement de livre trouvé',
    createSuccess: 'Emplacement de livre créé avec succès',
    createError: 'Échec de la création de l\'emplacement de livre',
    updateSuccess: 'Emplacement de livre mis à jour avec succès',
    updateError: 'Échec de la mise à jour de l\'emplacement de livre',
    deleteSuccess: 'Emplacement de livre supprimé avec succès',
    deleteError: 'Échec de la suppression de l\'emplacement de livre',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer l\'emplacement de livre {code}?',
    allBranches: 'Toutes les succursales',
    search: 'Rechercher...',
    gridView: 'Vue en grille',
    listView: 'Vue en liste',
    occupied: 'Occupé',
    available: 'Disponible',
    capacity: 'Capacité:',
    locationCode: 'Code d\'emplacement',
    locationName: 'Nom de l\'emplacement',
    section: 'Section',
    shelf: 'Étagère',
    row: 'Rangée',
    column: 'Colonne',
    floor: 'Étage',
    room: 'Salle',
    notes: 'Notes',
    isActive: 'Actif',
    edit: 'Modifier',
    delete: 'Supprimer',
    editBookLocation: 'Modifier l\'emplacement de livre',
    addNewBookLocation: 'Ajouter un nouvel emplacement de livre',
    selectBranch: 'Sélectionner la succursale',
    locationCodeRequired: 'Le code d\'emplacement est requis',
    optionalName: 'Nom optionnel',
    shelfRowColumn: 'Étagère/Rangée/Colonne',
    status: 'Statut',
    actions: 'Actions',
    roomName: 'Nom de la salle',
    numberOfBooks: 'Nombre de livres',
    active: 'Actif',
    yes: 'Oui',
    additionalNotes: 'Notes supplémentaires...',
    saving: 'Enregistrement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    name: 'Nom',
  },
}

